export default {"spinner":"fiH-c"};